import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const WholeHouseFoundationId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseFoundationIds
);

export const WholeHouseFoundationBasementId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseFoundationBasementIds
);

export const WholeHouseFramingId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseFramingIds
);

export const WholeHouseDecksAndPorchesId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseDecksAndPorchesIds
);

export const WholeHouseEwpFloorRoofLayoutId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseEwpFloorRoofLayoutIds
);

export const WholeHouseDimensionalFloorRoofLayoutId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseDimensionalFloorRoofLayoutIds
);

export const WholeHouseExteriorFinishesId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseExteriorFinishesIds
);

export const WholeHouseInteriorFinishesId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseInteriorFinishesIds
);

export const WholeHouseOpeningsId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseOpeningsIds
);

export const WholeHouseRoofingId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseRoofingIds
);

export const WholeHouseFlatRoofingId = iotsUtils.fromList(
	constants.job.subAncillaryItem.wholeHouseFlatRoofingIds
);

export const Id = iotsUtils.fromList(constants.job.subAncillaryItem.ids);
